var React = require('react');

function Scholar (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M11.481 13.786a.534.534 0 01-.412 0l-4.883-1.84-1.126-.427v1.333a6.07 6.07 0 006.064 6.064h.268a6.07 6.07 0 006.065-6.064v-1.443l-1.127.454-4.849 1.923z","fill":"#4541E3","key":0}),React.createElement("path",{"d":"M21.626 7.103L11.48 3.12a.587.587 0 00-.405 0L.37 7.103a.562.562 0 000 1.058l2.452.913v4.197a.563.563 0 001.126 0V9.493l1.127.42v.39l1.126.427 5.069 1.902 5.075-2.06 1.127-.454v-.233a.392.392 0 000-.09l4.168-1.641a.564.564 0 000-1.05h-.013z","fill":"#4541E3","key":1})]);
}

Scholar.defaultProps = {"viewBox":"0 0 22 22","fill":"none"};

module.exports = Scholar;

Scholar.default = Scholar;
